// extracted by mini-css-extract-plugin
module.exports = {"YoutubeEmbed":"bal_a"};